import close_icon from "./img/majesticons_close.svg";
import { Modal } from "@mui/material"
import classNames from "classnames";
import React, {
    // createRef,
    Dispatch,
    FC,
    SetStateAction,
    // useEffect,
    // useRef,
    // useState,
} from "react";
import { CloseIcon, SearchIcon } from "../common/Icons";
import styles from "./SuccessPopup.module.scss";
import { twJoin } from "tailwind-merge";
import { useTranslation } from "react-i18next";

interface ICreateData {
    show: boolean;
    setShow: Dispatch<SetStateAction<boolean>>;
    name: string;
    employeeID?: string;
    position?: any;
    qr_image?: any;
}
const BusinessCardPopup: FC<ICreateData> = ({ show, setShow, name,employeeID,position,qr_image }) => {
    const { t } = useTranslation();

    return (
        <div>
            <Modal open={show} onClose={() => setShow(false)} disableEnforceFocus={true}>
                <div>
                    <div className={classNames("z-10 fixed top-0 left-0 w-full h-full")}>
                        <div
                            className={classNames(
                                "relative z-10 top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 bg-[#fff] rounded-xl h-full"
                            )}
                        >
                            <div className={twJoin("max-w-full overflow-hidden bg-white md:max-w-[360px] mx-auto pt-20 qr_form")}>
                                <div className="max-w-full mx-auto">
                                    <div className="change-password-container px-5 ">
                                        <div className="py-5 relative left-0 w-full top-0 bg-white">
                                            <h3 className="heading2 font-secondary text-center text-sat_darkblackv2 w-full">
                                                {t("my_business_card")}
                                            </h3>
                                            <button onClick={() => setShow(false)} className="absolute right-0 top-1/2 -translate-y-1/2">
                                                <img src={close_icon} alt="back" className="" />
                                            </button>
                                        </div>
                                        <div className="pt-8 pb-8 h-auto flex flex-col justify-between">
                                            <div>
                                                <div className="mt-5 max-w-[264px] mx-auto">
                                                    <div className="border-2 border-sat_border rounded-[20px] bg-white p-5 block w-full 
                                                    shadow-[0_4px_4px_0_gba(0,0,0,0.08)]">
                                                        <div>
                                                            <div className="text-left flex items-center justify-between">
                                                                <div>
                                                                    <p className="heading2 text-sat_darkblackv2 font-bold leading-[135%]">
                                                                        {name}
                                                                    </p>
                                                                    <p className="text-button text-sat_darkgray400 font-normal leading-[150%]">
                                                                        {employeeID}
                                                                    </p>
                                                                    <p className="heading3 text-sat_darkblackv2 font-normal mt-1 leading-[nomal]">
                                                                        {position}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div className="mt-5">
                                                                <img
                                                                    src={qr_image}
                                                                    alt="qr_image"
                                                                    className="max-w-full object-cover w-full mx-auto border-4 border-sat_borderv2 rounded-xl aspect-[196/196] p-[14px]"
                                                                />
                                                                <div className="mt-3 text-button font-normal text-center leading-[150%] text-sat_darkgray400">
                                                                    Scan QR Code to Save Contact
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    );
};
export default BusinessCardPopup;
